"use client";

import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import { Button } from '@/components/ui/button';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from '@/utils/supabase/client';
import { useQuery } from "@tanstack/react-query";
import { showSuccess, showError } from '@/utils/toast';
import { Clock } from "lucide-react";

const schema = z.object({
  description: z.string().min(1, "Description is required"),
  start_time: z.string().min(1, "Start time is required"),
  end_time: z.string().optional(),
  duration_minutes: z.number().min(1, "Duration must be at least 1 minute").optional(),
  billable: z.boolean().default(true),
  task_id: z.string().optional(),
  project_id: z.string().optional(),
  client_id: z.string().optional(),
});

type FormData = z.infer<typeof schema>;

interface TimeEntryFormProps {
  onSuccess?: () => void;
};

export const TimeEntryForm: React.FC<TimeEntryFormProps> = ({ onSuccess }: TimeEntryFormProps) => {
  return null;
};